export default function EquipmentFullFiltersDirective() {
  return {
    restrict: 'E',
    template: require('./equipment-full-filters.component.html'),
    scope: {
      filters: '='
    },
    controller: EquipmentFullFiltersController
  };


  function EquipmentFullFiltersController($rootScope, $scope, securityGroupsService) {
    'ngInject';
    $scope.applyFilter = {};
    $scope.applyFilter.priorities = [];
    $scope.applyFilter.maintenance = [];
    $scope.applyFilter.securityGroups = [];
    $scope.securityGroups = [];
    $scope.priorities = {};
    $scope.maintenance = {};
    $scope.showGroups = false;
    var currentUser = $rootScope.currentUser;

    function getSecurityGroups() {
      if (currentUser.account.securityMode === 'Open') {
        $scope.securityGroups = [];
        return;
      }
      if (currentUser.securityMode !== 'Open') {
        $scope.securityGroups = currentUser.groups.data;
        if ($scope.securityGroups.length > 1) {
          $scope.showGroups = true;
        }
      } else {
        securityGroupsService.getAllSecurityGroups().then(function (response) {
          $scope.securityGroups = response.data.data;
          if ($scope.securityGroups.length > 0) {
            $scope.showGroups = true;
          }
        }, function (error) {
          $scope.securityGroups = [];
        });
      }
    }

    getSecurityGroups();

    $scope.applyButtonPressed = function () {

      $scope.applyFilter = {};
      $scope.applyFilter.priorities = [];
      $scope.applyFilter.maintenance = [];
      $scope.applyFilter.securityGroups = [];

      for (var i = 0; i < $scope.securityGroups.length; i++) {
        if ($scope.securityGroups[i]._selected) {
          $scope.applyFilter.securityGroups.push($scope.securityGroups[i].id);
        }
      }

      if ($scope.priorities.low) {
        $scope.applyFilter.priorities.push("low");
      }

      if ($scope.priorities.medium) {
        $scope.applyFilter.priorities.push("medium");
      }

      if ($scope.priorities.high) {
        $scope.applyFilter.priorities.push("high");
      }

      if ($scope.maintenance.overdue) {
        $scope.applyFilter.maintenance.push("due");
      }

      if ($scope.maintenance.upcoming) {
        $scope.applyFilter.maintenance.push("upcoming");
      }

      $scope.filters = $scope.applyFilter;

    };

    $scope.clearButtonPressed = function () {
      for (var i = 0; i < $scope.securityGroups.length; i++) {
        $scope.securityGroups[i]._selected = false;
      }

      $scope.priorities.low = false;
      $scope.priorities.medium = false;
      $scope.priorities.high = false;
      $scope.maintenance.overdue = false;
      $scope.maintenance.upcoming = false;
    };
  }
}